import { Request } from 'api';
import { AxiosResponse } from 'axios';
import { Session } from 'utils';

type ReturnType = Promise<AxiosResponse<Session>>;

const unpublishSession = (session: Session): ReturnType => {
    return Request.post(`/workouts/sessions/${session.uuid}/unpublish`);
};

export default unpublishSession;
